import { graphql } from '~publish/graphql'
import type { ResultOf } from '~publish/graphql'

import { PostMediaAsset_Asset } from '~publish/components/PostCard/PostMedia/PostMediaAsset'

export const CalendarPostCard_Post = graphql(
  `
    fragment CalendarPostCard_Post on Post {
      __typename
      id
      postGroup {
        id
        title
      }
      status
      tags {
        id
        color
        name
      }
      metadata {
        ... on CommonPostMetadata {
          type
        }
        ... on GoogleBusinessPostMetadata {
          title
        }
        ... on ThreadsPostMetadata {
          topic
        }
      }
      assets {
        __typename
        ...PostMediaAsset_Asset
      }
      dueAt
      schedulingType
      isCustomScheduled
      isPinned
      notificationStatus
      text
      channelId
      channelService
      channel {
        id
        serviceId
        type
        name
      }
      recurrence {
        cadence {
          frequency
          frequencyStep
        }
        maxRecurrentPosts
        recurrentPostsLeft
      }
    }
  `,
  [PostMediaAsset_Asset],
)

export type CalendarPostCard_PostData = ResultOf<typeof CalendarPostCard_Post>
